import { render, staticRenderFns } from "./DeliveryChallanList.vue?vue&type=template&id=29087cdd&scoped=true&"
import script from "./DeliveryChallanList.vue?vue&type=script&lang=js&"
export * from "./DeliveryChallanList.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryChallanList.vue?vue&type=style&index=0&id=29087cdd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29087cdd",
  null
  
)

export default component.exports